import React from 'react'
import { Routes ,Route} from 'react-router-dom'
import AILandingPage from './pages/Dashboard/AILandingPage'
import VoiceToVoice from './pages/VoiceToVoice'


const App = () => {
  return (
    <Routes>
      <Route path='/' element={<AILandingPage/>}/>
      <Route path='/voice-to-voice' element={<VoiceToVoice/>}/>
    
    </Routes>
  )
}

export default App
